module.exports = __webpack_public_path__ + "img/gb-sct.d5044179.svg";